import {Divider, Link as MuiLink, Typography} from '@mui/material';
import {Box} from '@jobseeker/lotus/foundations';
import {Link} from '@jobseeker/lotus/elements';
import Menu from '../../Menu/Menu';
import {StyledTab, StyledSpan, StyledTabs} from '../style';
import {Image} from '@jobseeker/lotus/components/Image';
import {ChevronDown} from '@jobseeker/lotus/assets/icons';
import {handleTracking} from '@jobseeker/common-core/utils/analytics';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {TrackEventUBA, deferTask} from '@jobseeker/common-core/utils';

import {shallowEqual, useSelector} from 'react-redux';
import type {BaseSyntheticEvent, SyntheticEvent} from 'react';
import type {NavPropType} from '../types';
import type {AppState} from '@jobseeker/common-core/types';
import type {MenuItemType} from '@jobseeker/lotus/components/Menu/types';

const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const NavContent = (props: NavPropType) => {
  const {
    tabsList = [],
    courses = [],
    theme,
    value,
    open,
    anchorEl,
    selected,
    moreMenu,
    selectedNav,
    toShowSelect,
    showCourses,
    courseLink,
    showPremium,
    handleOnClick,
    handleTabChange,
    handleMenuOpen,
    handleMenuClose,
  } = props || {};


  const specializedList = isAppIimjobs && Array.isArray(tabsList) && tabsList.length > 6
    ? [{
        heading: 'Specialized Jobs',
        label: 'Specialized Jobs',
        dataId: '28',
        tag: 'specialized jobs',
        menu: (() => {
          const rest = tabsList.slice(6);
          if (rest.length === 0) return [];
          const last = rest[rest.length - 1];
          const others = rest.slice(0, rest.length - 1);
          return [last, ...others];
        })(),
      }]
    : [];

  let menu: string | any[] = [];

  const isSpecializedCategory = isAppIimjobs && value >= tabsList.length;

  if (value > -1) {
    if (value === 12) {
      menu = courses;
    } else {
      menu = moreMenu > 3
        ? tabsList.slice(3) || [{}]
        : isSpecializedCategory
          ? specializedList[0]?.menu
          : tabsList[value]?.menu;
    }
  }

  const isMenuSelected = (index: number) => {
    if (toShowSelect) {
      return false;
    }

    if (selectedNav > -1) {
      return selectedNav === index;
    }
    return selected === index;
  };

  const handlePremiumClick = () => {
    const event = 'jsClickGoPremium';

    if (window && window.location) {
      const urlParams = new URLSearchParams(window.location.search);
      const ref = urlParams.get('ref') ?? '';

      handleTracking(event, {
        event_category: 'Subscription',
        Origin: 'Jobfeed',
        RefText: ref,
        UserId: sessionStorage.getItem('userId') || 'NA',
        Device: sessionStorage.getItem('device') || 'desktop',
        Device_Type: sessionStorage.getItem('deviceType') || 'web',
        Status: sessionStorage.getItem('status') || 'LoggedOut',
      });

      openUrl(`/subscribe/plans`, '_self');
    }
  };

  const getRelativeTagLink = (menu: MenuItemType[]) => {
    return menu && menu?.length > 0 && menu[0]?.tag
      ? `/c/${menu[0].tag
          .replace('&', '')
          .replace(/\s+/g, '-')
          .toLowerCase()}-jobs${!isAppIimjobs ? '?ref=topnavigation' : ''}`
      : '#';
  };

  const page = useSelector((state: AppState) => state.app.page, shallowEqual);

  const trackEvent = (
    section: string,
    opts?: {categoryId?: string; tagId?: string; clickedMenuName?: string}
  ) => {
    TrackEventUBA('topMenuClick', 'click', {
      section,
      categoryID: opts?.categoryId,
      tagID: opts?.tagId,
      page,
      sessionUsername: sessionStorage.getItem('userId') || '',
      clickedMenuName: opts?.clickedMenuName,
    });
  };
  return (
    <Box
      display={{xxs: 'none', lg: 'flex'}}
      position={'relative'}
      marginLeft={theme.spacing(6.25)}
      onMouseLeave={handleMenuClose}
    >
      {tabsList?.map((tab, i) => {
        const tabDataId = tab?.dataId;
        const url = tab?.tag
          ? `/c/${tab?.tag
              .replace('&', '')
              .replace(/\s+/g, '-')
              .toLowerCase()}-jobs?ref=${
              isAppIimjobs ? 'nav' : 'topnavigation'
            }`
          : !isAppIimjobs
            ? getRelativeTagLink(menu)
            : '#';
        return (
          <Box key={i} sx={{display: 'none'}}>
            <Box key={`nav-content-box-${i}`}>
              <a
                href={url}
                target="_self"
                style={{
                  textDecoration: 'none',
                  color: 'inherit',
                }}
              >
                {tab?.label}
              </a>
              {tab.menu?.map((submenu, j) => {
                const href = `/k/${submenu.tag
                  ?.replace(/&/g, '')
                  .replace(/\s+/g, '-')
                  .toLowerCase()}-jobs?ref=${
                  isAppIimjobs ? 'nav' : 'topnavigation'
                }`;

                return (
                  <Box key={j}>
                    <Typography>
                      <a
                        href={href}
                        onClick={e => {
                          e.preventDefault();
                          deferTask(() => {
                            trackEvent('Tag', {
                              categoryId: tabDataId,
                              tagId: submenu.dataId,
                              clickedMenuName: submenu.label,
                            });
                            openUrl(href, '_self');
                          });
                        }}
                        style={{textDecoration: 'none', color: 'inherit'}}
                        target="_self"
                      >
                        {submenu.label}
                      </a>
                    </Typography>

                    {Array.isArray(submenu.menu) && (
                      <Box component="ul" sx={{pl: 2, m: 0}}>
                        {submenu.menu.map((menu, k) => {
                          const nestedHref = `/k/${menu.tag
                            ?.replace(/&/g, '')
                            .replace(/\s+/g, '-')
                            .toLowerCase()}-jobs?ref=${
                            isAppIimjobs ? 'nav' : 'topnavigation'
                          }`;
                          return (
                            <Box
                              component="li"
                              key={k}
                              sx={{listStyle: 'disc'}}
                            >
                              <Typography component="span">
                                <a
                                  href={nestedHref}
                                  onClick={e => {
                                    e.preventDefault();
                                    deferTask(() => {
                                      trackEvent('Tag', {
                                        categoryId: tabDataId,
                                        tagId: menu.dataId,
                                        clickedMenuName: menu.label,
                                      });
                                      openUrl(nestedHref, '_self');
                                    });
                                  }}
                                  style={{
                                    textDecoration: 'none',
                                    color: 'inherit',
                                  }}
                                  target="_self"
                                >
                                  {menu.label}
                                </a>
                              </Typography>
                            </Box>
                          );
                        })}
                      </Box>
                    )}
                  </Box>
                );
              })}
            </Box>
          </Box>
        );
      })}

      <StyledTabs
        value={value > -1 ? (value === 12 ? 0 : value) : 0}
        onChange={handleTabChange}
        TabIndicatorProps={{sx: {display: 'none'}}}
      >
        {isAppIimjobs && specializedList.length > 0 ? (
          <>
            {tabsList.slice(0, tabsList.length - 3).map((tabs, index) => {
              const {label, tag, menu} = tabs || {};
              const dataId = parseInt(tabs?.dataId);
              const url = tag
                ? `/c/${tag
                    .replace('&', '')
                    .replace(/\s+/g, '-')
                    .toLowerCase()}-jobs?ref=nav`
                : '#';
              return (
                <Box key={`nav-content-box-${index}`} display="block">
                  <a
                    href={url}
                    onClick={e => {
                      e.preventDefault();
                      deferTask(() => {
                        if (url !== '#') {
                          trackEvent('Category', {
                            categoryId: tabs?.dataId,
                            clickedMenuName: label,
                          });
                          openUrl(url, '_self');
                        }
                      });
                    }}
                    target="_self"
                    style={{textDecoration: 'none', color: 'inherit'}}
                  >
                    <StyledTab
                      value={index}
                      theme={theme}
                      onMouseEnter={(event: BaseSyntheticEvent<object, any, any>) => {
                        handleMenuOpen(event, index);
                      }}
                      data-key={index}
                      label={label}
                      onClick={(event: SyntheticEvent<Element, Event>) => {
                        deferTask(() => {
                          handleOnClick(event, index);
                          handleMenuClose();
                        });
                      }}
                      aria-owns={open ? 'menu-list-grow' : undefined}
                      aria-haspopup={'true'}
                      sx={{
                        color: isMenuSelected(dataId)
                          ? theme.palette.primary.main
                          : '',
                      }}
                    />
                    <StyledSpan theme={theme} visible={isMenuSelected(dataId)} />
                  </a>
                </Box>
              );
            })}
            <Divider
              orientation="vertical"
              variant="middle"
              sx={{
                border: '0.60px #333333 solid',
                my: `${theme.spacing(2.75)} !important`,
              }}
              flexItem
            />
            {specializedList.map((otherTabs, oIdx) => {
              const {label, tag, menu: tabMenu} = otherTabs || {};
              const parentDataId = parseInt(otherTabs?.dataId, 10);
              const childDataIds: number[] = Array.isArray(tabMenu)
                ? (tabMenu as any[])
                    .map((m: any) => parseInt(m?.dataId as string, 10))
                    .filter((n: number) => !Number.isNaN(n))
                : [];
              const effectiveDataId =
                typeof selectedNav === 'number' &&
                childDataIds.includes(selectedNav)
                  ? selectedNav
                  : parentDataId;
              const tabValue = tabsList.length + oIdx;
              return (
                <Box
                  key={`nav-content-box-specialized-${tabValue}`}
                  display="block"
                >
                  {oIdx === 0 && (
                    <Box
                      sx={{
                        top: '3px',
                        right: 8,
                        width: '38px',
                        height: '17px',
                        borderRadius: '40px',
                        background: '#E5EFFE',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        opacity: 1,
                        zIndex: 2,
                        marginTop: '6px',
                      }}
                    >
                      <Typography
                        sx={{
                          width: '23px',
                          height: '16px',
                          fontWeight: 500,
                          fontStyle: 'italic',
                          fontSize: '9px',
                          lineHeight: '16px',
                          letterSpacing: '1px',
                          textAlign: 'center',
                          color: '#4C6FFF',
                          opacity: 1,
                        }}
                      >
                        NEW
                      </Typography>
                    </Box>
                  )}
                  <a
                    href={'#'}
                    onClick={e => e.preventDefault()}
                    target="_self"
                    style={{textDecoration: 'none', color: 'inherit'}}
                  >
                    <StyledTab
                      value={tabValue}
                      theme={theme}
                      onMouseEnter={e => handleMenuOpen(e, tabValue)}
                      data-key={tabValue}
                      label={label}
                      onClick={e => {
                        deferTask(() => {
                          handleOnClick(e, tabValue);
                          handleMenuClose();
                        });
                      }}
                      aria-owns={open ? 'menu-list-grow' : undefined}
                      aria-haspopup="true"
                      sx={{
                        color: isMenuSelected(effectiveDataId)
                          ? theme.palette.primary.main
                          : '',
                        justifyContent: 'flex-start',
                        minHeight: '30px',
                        pb: '19px',
                      }}
                    />
                    <StyledSpan
                      theme={theme}
                      visible={isMenuSelected(effectiveDataId)}
                    />
                  </a>
                </Box>
              );
            })}
          </>
        ) : (
          <>
            {tabsList.map((tabs, index) => {
              const {label, tag, menu} = tabs || {};
              const dataId = parseInt(tabs?.dataId);
              const url = tag
                ? `/c/${tag
                    .replace('&', '')
                    .replace(/\s+/g, '-')
                    .toLowerCase()}-jobs?ref=${
                    isAppIimjobs ? 'nav' : 'topnavigation'
                  }`
                : !isAppIimjobs
                  ? getRelativeTagLink(menu)
                  : '#';
              return (
                <Box key={`nav-content-box-${index}`} display="block">
                  <a
                    href={url}
                    onClick={e => {
                      e.preventDefault();
                      deferTask(() => {
                        if (url !== '#') {
                          trackEvent('Category', {
                            categoryId: tabs?.dataId,
                            clickedMenuName: label,
                          });
                          openUrl(url, '_self');
                        }
                      });
                    }}
                    target="_self"
                    style={{textDecoration: 'none', color: 'inherit'}}
                  >
                    <StyledTab
                      value={index}
                      theme={theme}
                      onMouseEnter={(event: BaseSyntheticEvent<object, any, any>) => {
                        handleMenuOpen(event, index);
                      }}
                      data-key={index}
                      label={
                        tabs?.dataId === 'others' ? (
                          <Box display="flex" alignItems="center" gap={0.5}>
                            {label}
                            <Image
                              src={ChevronDown}
                              alt=""
                              width={10}
                              height={10}
                            />
                          </Box>
                        ) : (
                          label
                        )
                      }
                      onClick={(event: SyntheticEvent<Element, Event>) => {
                        deferTask(() => {
                          handleOnClick(event, index);
                          handleMenuClose();
                        });
                      }}
                      aria-owns={open ? 'menu-list-grow' : undefined}
                      aria-haspopup={'true'}
                      sx={{
                        color: isMenuSelected(dataId)
                          ? theme.palette.primary.main
                          : '',
                      }}
                    />
                    <StyledSpan theme={theme} visible={isMenuSelected(dataId)} />
                  </a>
                </Box>
              );
            })}
          </>
        )}
      </StyledTabs>

      {showCourses && (
        <Box
          display={{xxs: 'none', md: 'inline-flex'}}
          marginLeft={theme.spacing(1.5)}
        >
          <Divider
            orientation="vertical"
            variant="middle"
            sx={{
              border: isAppIimjobs
                ? '0.60px #333333 solid'
                : '0.60px solid #e9e8e8',
              my: `${theme.spacing(isAppIimjobs ? 2.75 : 2.5)} !important`,
            }}
            flexItem
          />
          <Link
            sx={{
              display: {xxs: 'none', sm: 'inline-flex'},
              marginLeft: theme.spacing(1.5),
              marginTop: theme.spacing(isAppIimjobs ? 2.5 : 2.75),
              opacity: 1,
              padding: 0,
              fontWeight: isAppIimjobs
                ? theme.typography.fontWeightMedium
                : theme.typography.fontWeightLight,
              ':hover': {textDecoration: 'none'},
            }}
            href={courseLink}
            target="_blank"
            onClick={(e: any) => {
              e.preventDefault();
              trackEvent('Courses', {clickedMenuName: 'Courses'});
              if (courseLink) {
                deferTask(() => openUrl(courseLink, '_blank'));
              }
            }}
            onMouseEnter={(event: React.SyntheticEvent) => {
              handleTabChange(event, 12);
              handleMenuOpen(event, 12);
            }}
          >
            Courses{''}
          </Link>
        </Box>
      )}

      {!!showPremium && (
        <MuiLink
            onClick={() => {
              deferTask(() => {
                handlePremiumClick();
              });
            }}
            display={'flex'}
            height={'fit-content'}
            sx={{
              m: '11px 0 0 25px',
              p: '11px 13px 12px',
              borderRadius: 2,
              backgroundColor: '#13355c',
              textDecoration: 'none',
              fontSize: 12,
              fontWeight: 700,
              color: '#feae02!important',
              textTransform: 'uppercase',
              cursor: 'pointer',
              ':hover': {
                backgroundColor: '#1c4370',
              },
            }}
          >
            <Box
              sx={{
                position: 'absolute',
                fontSize: 10,
                fontWeight: 700,
                color: '#fff',
                right: '6px',
                top: '4px',
                width: '32px',
                padding: '2px 3px 0 4px',
                borderRadius: '3px',
                backgroundColor: '#feae02',
              }}
            >
              NEW
            </Box>
            <Image
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAiCAMAAAAnKQpfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABIUExURUdwTP//4f+/Kf/FLv+/KP/CLf+/KP+/Kf/AKf/KNv/AKf+/KP+/KP/AKv+/Kf+/Kf+/KP+/KP/BK/+/Kf+/KP+/Kf+/Kf++KAX0DW0AAAAXdFJOUwABqQ+/Gfv0PARS6uBEebRp8CnXyJSBRhWSlQAAAZRJREFUOMvFVduygyAMVJSLoIKg3f//0xOo9UCFzvSpOx2nQBI3mwS77tfgzBjGv3KZ+AbC9p2XBePcwrYt+kHrMma/Yei6AVtfcs7snATEIz+fhJhez/9IDwFI91xowDIBl8cccUzTgTHfcxDMAjot9mi/YM4NvIGUMD7fm7FEzz0tZOTfmfS8+Omons59Bpj03NIqQFGOokz6wEG/UhxBKiiEtFoxOx2wLXlYCe8h85cvG4J2M9YnFRupkIKZgCyWiIqVSZdMSLOXoPrYwVaBkV8WkjTw8orDR4iVYT/yNLkQXBkYFwmp8dRAUxwVyTo6UtGm7ApGXDmjIoed2s6c+S2GGnAPVFTLKXf21kpUJ2KibOQ9r5cAwzrThrAUpE91KrstPLd67snjUoT+DIp2+lfYEq+X91OjrdkpdtHptzTfprJ6XolUY1KTojlzdxlyKepohaQeHJuYG+Q5PqIuUy+gmgAaCZdz2N0nsIYA33Ly5+zdsccRrkOdV0PthtRTA7p5b7JP4rGGkzayCaN/8h36A5tNHYcT17qLAAAAAElFTkSuQmCC"
              alt="crown_img"
              width={26}
              height={17}
              style={{
                marginRight: '6px',
              }}
            />
            Go Premium
          </MuiLink>
      )}

      {menu?.length > 0 && (
        <Menu
          indexTab={value}
          value={moreMenu}
          open={open}
          anchorEl={anchorEl}
          menuItems={menu}
          handleMenuClose={handleMenuClose}
          theme={theme}
          width={isAppIimjobs ? '280px' : '100%'}
          menuType={
            value === 12
              ? 'course'
              : moreMenu > 3 || isSpecializedCategory
                ? 'category'
                : 'tag'
          }
          parentCategoryId={
            value === 12 || moreMenu > 3 || isSpecializedCategory
              ? undefined
              : tabsList[value]?.dataId
          }
        />
      )}
    </Box>
  );
};

export default NavContent;
